import convert from "units-converter";

export const lengthConvert = (value, from, to) => {
  return convert.length(value).from(from).to(to);
};
